'use strict';

wbApp.factory('onlinePaymentsSvc', ['$resource', '$q', '$filter', 'repositorySvc', '$window', '$translate', 'notificationSvc',
    function ($resource, $q, $filter, repositorySvc, $window, $translate, notificationSvc) {
        var OnlinePayment = $resource('/Api/OnlinePayments/GetAll', {}, {            
            'startOnlinePayment': { method: 'POST', url: '/Api/OnlinePayments/StartOnlinePayment' },
            'getTransactionState': { method: 'POST', url: '/Api/OnlinePayments/GetTransactionState' },
            'getAllByDateRange': { method: 'GET', isArray: true, url: '/Api/OnlinePayments/getAllByDateRange' },
            'delete': { method: 'POST', url: '/Api/OnlinePayments/Delete' },
            'reverse': { method: 'POST', url: '/Api/OnlinePayments/Reverse' },
            'manualReverse': { method: 'POST', url: '/Api/OnlinePayments/ManualReverse' }
        });

        var byDateRanges = null;
        var lastFromDate = null;
        var lastToDate = null;

        function getAllByDateRange(fromDate, toDate, refresh) {

            if (!byDateRanges || lastFromDate != fromDate || lastToDate != toDate || refresh) {

                lastFromDate = fromDate;
                lastToDate = toDate;

                byDateRanges = repositorySvc.customGet('getAllByDateRange', OnlinePayment, {
                    fromDate: fromDate,
                    toDate: toDate
                });
            }

            return byDateRanges;
        }

        function startOnlinePayment(invoiceIDs, price) {
            var result = OnlinePayment['startOnlinePayment']({
                invoiceIDs: invoiceIDs,
                price: price,
                returnToUrl: $window.location.href
            });

            result.$promise.then(function (data) {                
                $window.location.href = data.redirectUrl;
            }, function (error) {
                repositorySvc.defaultErrorHandler(error, null, 'TXT_PAYMENT_CANNOT_BE_STARTED');
            });

            return result;
        }

        function getTransactionState(onlinePaymentID) {
            return OnlinePayment['getTransactionState']({
                onlinePaymentID: onlinePaymentID
            });
        }

        function getOnlinePaymentResultMessage(onlinePayment) {

            var priceStr = $filter('wbCurrencyFlt')(onlinePayment.price);

            switch (onlinePayment.state) {
                case 2: // Pending
                    return '<i class="fa fa-spinner fa-pulse fa-3x fa-fw text-warning pull-right" aria-hidden="true"></i>' +
                        $translate.instant('TXT_PAYMENT_RESULT_PENDING').f(priceStr);
                case 3: // Paid
                    return '<i class="fa fa-3x fa-check text-success pull-right" aria-hidden="true"></i>' +
                        $translate.instant('TXT_PAYMENT_RESULT_PAID').f(priceStr);
                case 4: // Reversed
                case 5: // AutoReversed
                    return '<i class="fa fa-spinner fa-pulse fa-3x fa-fw text-warning pull-right" aria-hidden="true"></i>' +
                        $translate.instant('TXT_PAYMENT_RESULT_REVERSED').f(priceStr);
                case 6: // Cancelled
                    return '<i class="fa fa-ban fa-3x text-danger pull-right" aria-hidden="true"></i>' +
                        $translate.instant('TXT_PAYMENT_RESULT_CANCELLED').f(priceStr);
                case 7: // Declained
                    return '<i class="fa fa-ban fa-3x text-danger pull-right" aria-hidden="true"></i>' +
                        $translate.instant('TXT_PAYMENT_RESULT_DECLAINED').f(priceStr);
                case 8: // Error
                    return '<i class="fa fa-ban fa-3x text-danger pull-right" aria-hidden="true"></i>' +
                        $translate.instant('TXT_PAYMENT_RESULT_ERROR').f(priceStr, onlinePayment.resultMessage);
                default: // Unexpected
                    return '<i class="fa fa-ban fa-3x text-danger pull-right" aria-hidden="true"></i>' +
                        $translate.instant('TXT_PAYMENT_RESULT_UNEXPECTED').f(priceStr);
            }
        }


        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                OnlinePayment,                            // $resource
                byDateRanges,                             // collection
                { onlinePaymentID: data.onlinePaymentID },           // entity
                successCallback,
                errorCallback,
                {
                    onlinePaymentID: data.onlinePaymentID
                },
                'onlinePaymentID');
        }

        function reverse(onlinePaymentID) {
            return $q(function (resolve, reject) {
                repositorySvc.customPost(
                    'reverse',
                    OnlinePayment,
                    { onlinePaymentID: onlinePaymentID },
                    function (data) {
                        repositorySvc.entityUpdated(byDateRanges, data, 'onlinePaymentID');
                        resolve(data);
                    },
                    function (err) {
                        reject(err);
                    });
            });
        }

        function manualReverse(onlinePaymentID) {
            return $q(function (resolve, reject) {
                repositorySvc.customPost(
                    'manualReverse',
                    OnlinePayment,
                    {
                        onlinePaymentID: onlinePaymentID
                    },
                    function (data) {
                        repositorySvc.entityUpdated(byDateRanges, data, 'onlinePaymentID');
                        resolve(data);
                    },
                    function (err) {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_CHANGES_SAVE_ERROR'),
                            notificationSvc.translateError(err));                        
                        reject(err);
                    });
            });
        }        

        return {
            startOnlinePayment: startOnlinePayment,
            getTransactionState: getTransactionState,
            getOnlinePaymentResultMessage: getOnlinePaymentResultMessage,
            getAllByDateRange: getAllByDateRange,
            remove: remove,
            reverse: reverse,
            manualReverse: manualReverse
        }
    }
]);
